export enum AccountType {
  Bidder = 'Bidder',
  Whale = 'Whale',
  Default = 'default',
}
